/* Optimum Fusion cart helpers:
   1) After "Add to cart": a simple popup with Go to Cart / Continue Shopping (+ a Bundle & Save 15% suggestion)
   2) In the cart drawer and cart page: a Bundle & Save 15% suggestion above Checkout, and a Continue Shopping button */
(function () {
  var MAP = {
    'opti-isolate': ['opti-flexiglow', 'opti-charge-atp-1', 'opti-guard', 'opti-carbs'],
    'opti-beef': ['opti-flexiglow', 'opti-charge-atp-1', 'opti-guard', 'opti-carbs'],
    'opti-charge-atp-1': ['opti-flexiglow', 'opti-isolate', 'the-tribal-chief', 'opti-beef'],
    'opti-guard': ['opti-flexiglow', 'opti-isolate', 'opti-beef', 'the-head-of-the-table'],
    'opti-carbs': ['opti-flexiglow', 'the-head-of-the-table', 'opti-isolate', 'opti-charge-atp-1'],
    'the-head-of-the-table': ['opti-flexiglow', 'the-tribal-chief', 'opti-carbs', 'opti-guard'],
    'the-tribal-chief': ['opti-flexiglow', 'the-head-of-the-table', 'opti-charge-atp-1', 'opti-carbs'],
    'opti-911': ['opti-flexiglow', 'the-head-of-the-table', 'opti-charge-atp-1', 'opti-carbs'],
    'the-final-boss': ['opti-flexiglow', 'deep-dreams', 'the-head-of-the-table', 'opti-charge-atp-1'],
    'high-chief': ['opti-flexiglow', 'deep-dreams', 'the-head-of-the-table', 'opti-charge-atp-1'],
    'opti-ultra': ['opti-flexiglow', 'opti-marine', 'deep-dreams'],
    'opti-marine': ['opti-flexiglow', 'opti-ultra', 'cycle-shield'],
    'opti-flexiglow': ['opti-marine', 'opti-ultra', 'deep-dreams'],
    'deep-dreams': ['opti-flexiglow', 'opti-ultra', 'the-final-boss', 'opti-marine'],
    'bloodline': ['opti-flexiglow', 'cycle-shield', 'opti-ultra', 'opti-marine'],
    'cycle-shield': ['opti-flexiglow', 'bloodline', 'opti-marine', 'opti-ultra']
  };
  var AB = { 'opti-isolate': 'ISO', 'opti-beef': 'BEEF', 'opti-charge-atp-1': 'CREATINE', 'opti-guard': 'GLUTAMINE', 'opti-carbs': 'CARBS', 'the-head-of-the-table': 'EAA', 'the-tribal-chief': 'TRIBAL', 'opti-911': 'OPTI911', 'the-final-boss': 'FINALBOSS', 'high-chief': 'HIGHCHIEF', 'opti-ultra': 'MULTI', 'opti-marine': 'OMEGA3', 'opti-flexiglow': 'COLLAGEN', 'deep-dreams': 'DEEPDREAMS', 'bloodline': 'BLOODLINE', 'cycle-shield': 'CYCLESHIELD' };
  function bundleCode(a, b) { if (!AB[a] || !AB[b]) return ''; return 'BUNDLE-' + AB[b]; }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var productCache = {};
  var busy = false;
  var coolUntil = 0;
  var popupOpen = false;

  function money(cents) { return 'AED ' + (cents / 100).toFixed(2); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function onCartPage() { return location.pathname.replace(/\/$/, '') === (root + 'cart').replace(/\/$/, ''); }

  function getJSON(url) {
    return nativeFetch(url, { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(url); return r.json(); });
  }
  function getProduct(h) {
    if (!productCache[h]) productCache[h] = getJSON(root + 'products/' + h + '.js').catch(function () { return null; });
    return productCache[h];
  }
  function addToCart(id, qty, code) {
    return nativeFetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function (d) {
        if (!code) return d;
        return nativeFetch(root + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: code })
        }).then(function () { return d; }, function () { return d; });
      });
  }
  function refreshCartUI(openDrawer) {
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: !!openDrawer } }));
    getJSON(root + 'cart.js').then(function (c) {
      document.querySelectorAll('.cart-drawer-button .count, [data-cart-count]').forEach(function (n) {
        n.textContent = c.item_count; n.hidden = c.item_count === 0;
      });
    }).catch(function () {});
  }
  function hideDrawer() {
    document.querySelectorAll('cart-drawer').forEach(function (d) {
      if (d.open || d.hasAttribute('open')) {
        if (typeof d.hide === 'function') d.hide();
        else if (typeof d.close === 'function') d.close();
      }
    });
  }

  var OFFER = ['opti-flexiglow', 'opti-guard', 'high-chief'];
  function bundleUsed(cart) {
    var used = false;
    (cart.discount_codes || []).forEach(function (d) { if (/^BUNDLE-/i.test(d.code || '') && d.applicable !== false) used = true; });
    (cart.cart_level_discount_applications || []).forEach(function (d) { if (/^BUNDLE-/i.test(d.title || '')) used = true; });
    (cart.items || []).forEach(function (i) {
      (i.line_level_discount_allocations || []).forEach(function (a) {
        if (a.discount_application && /^BUNDLE-/i.test(a.discount_application.title || '')) used = true;
      });
    });
    return used;
  }
  function qtyOf(cart, h) { var q = 0; (cart.items || []).forEach(function (i) { if (i.handle === h) q += i.quantity; }); return q; }
  function bundleCodeIn(cart) {
    var c = '';
    (cart.discount_codes || []).forEach(function (d) { if (/^BUNDLE-/i.test(d.code || '')) c = d.code; });
    return c;
  }
  /* Bundle = 1 tub of each product. If either product goes above 1 tub, the bundle discount is removed. */
  var enforcing = false;
  function enforceBundle(cart) {
    return; /* BXGY code limits the discount to 1 tub of the added product */
    var code = bundleCodeIn(cart);
    if (!code || enforcing) return;
    var parts = code.toUpperCase().replace(/^BUNDLE-/, '').split('-');
    var handles = Object.keys(AB).filter(function (h) { return parts.indexOf(AB[h]) > -1; });
    var bad = handles.length !== 2 || handles.some(function (h) { return qtyOf(cart, h) !== 1; });
    if (!bad) return;
    enforcing = true;
    nativeFetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: '' })
    }).then(function () { if (onCartPage()) location.reload(); else refreshCartUI(false); enforcing = false; }, function () { enforcing = false; });
  }
  function pickSuggestion(cart, mainHandle) {
    if (!cart.items || !cart.items.length || bundleUsed(cart)) return Promise.resolve(null);
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.handle] = true; });
    var main = mainHandle || cart.items[0].handle;
    if (!AB[main] || qtyOf(cart, main) !== 1) return Promise.resolve(null);
    var list = OFFER.filter(function (h) { return h !== main && !inCart[h]; });
    if (!list.length) return Promise.resolve(null);
    return Promise.all(list.map(getProduct)).then(function (ps) {
      ps = ps.filter(function (p) { return p && p.available; });
      ps.forEach(function (p) { p._main = main; });
      return ps.length ? ps : null;
    });
  }

  function addStyles() {
    if (document.getElementById('of-upsell-css')) return;
    var st = document.createElement('style');
    st.id = 'of-upsell-css';
    st.textContent =
      '.of-upsell{margin:0 0 12px;padding:12px;border:1px solid rgba(62,166,183,.6);border-radius:12px;background:#f2fafb;color:#042e3a;text-align:left;display:grid;gap:10px;}' +
      '.of-upsell__tag{display:inline-block;background:#3ea6b7;color:#fff;font-weight:700;font-size:11px;letter-spacing:.5px;text-transform:uppercase;padding:3px 9px;border-radius:999px;}' +
      '.of-upsell__head{display:flex;flex-wrap:wrap;align-items:center;gap:8px;font-weight:700;font-size:14px;}' +
      '.of-upsell__row{display:flex;align-items:center;gap:10px;}' +
      '.of-upsell__img{width:56px;height:56px;background:#fff;border-radius:8px;border:1px solid rgba(62,166,183,.3);display:flex;align-items:center;justify-content:center;overflow:hidden;flex-shrink:0;}' +
      '.of-upsell__img img{width:100%;height:100%;object-fit:contain;}' +
      '.of-upsell__info{display:flex;flex-direction:column;gap:2px;min-width:0;flex:1;}' +
      '.of-upsell__title{font-size:13px;font-weight:600;line-height:1.3;}' +
      '.of-upsell__price{font-size:13px;}' +
      '.of-upsell__price s{opacity:.55;margin-right:6px;}' +
      '.of-upsell__select{width:100%;padding:8px 10px;border-radius:8px;border:1px solid rgba(62,166,183,.5);background:#fff;color:#042e3a;font-size:13px;}' +
      '.of-upsell__qty{display:flex;align-items:center;justify-content:space-between;gap:10px;font-size:13px;font-weight:600;}' +
      '.of-upsell__step{display:flex;align-items:center;border:1px solid rgba(62,166,183,.5);border-radius:999px;overflow:hidden;background:#fff;}' +
      '.of-upsell__step button{width:38px;height:36px;border:0;background:transparent;color:#042e3a;font-size:20px;line-height:1;cursor:pointer;}' +
      '.of-upsell__step input{width:40px;height:36px;border:0;text-align:center;font-size:15px;font-weight:700;color:#042e3a;background:#fff;-moz-appearance:textfield;}' +
      '.of-upsell__one{display:grid;gap:10px;}' +
      '.of-upsell__tabs{display:grid;grid-auto-flow:column;grid-auto-columns:minmax(0,1fr);gap:6px;}' +
      '.of-upsell__tab{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;padding:6px 4px;line-height:1.15;border:2px solid rgba(62,166,183,.35);border-radius:10px;background:#fff;color:#042e3a;font-weight:700;font-size:12px;cursor:pointer;text-align:center;}' +
      '.of-upsell__tab img{width:34px;height:34px;object-fit:contain;flex-shrink:0;}' +
      '.of-upsell__tab.is-on{border-color:#3ea6b7;background:#e6f5f7;box-shadow:0 0 0 1px #3ea6b7;}' +
      '.of-upsell__note{margin:0;font-size:12px;color:#3ea6b7;font-weight:600;}' +
      '.of-upsell__done{margin:0;font-size:14px;font-weight:700;color:#3ea6b7;}' +
      '.of-btn{display:block!important;width:100%!important;padding:13px!important;border:0!important;border-radius:999px!important;background:#3ea6b7!important;color:#fff!important;font-weight:700!important;font-size:15px!important;line-height:1.2!important;cursor:pointer;opacity:1!important;visibility:visible!important;text-align:center!important;text-decoration:none!important;}' +
      '.of-btn[disabled]{opacity:.6!important;cursor:default;}' +
      '.of-btn--ghost{background:transparent!important;color:#3ea6b7!important;border:2px solid #3ea6b7!important;}' +
      '.of-added{position:fixed;inset:0;z-index:2147483000;background:rgba(4,46,58,.65);display:flex;align-items:flex-end;justify-content:center;padding:16px;}' +
      '@media (min-width:700px){.of-added{align-items:center;}}' +
      '.of-added__box{width:100%;max-width:420px;max-height:90vh;overflow:auto;background:#fff;color:#042e3a;border-radius:16px;padding:18px;display:grid;gap:12px;box-shadow:0 10px 40px rgba(0,0,0,.3);}' +
      '.of-added__head{display:flex;align-items:center;gap:10px;font-weight:700;font-size:16px;line-height:1.3;}' +
      '.of-added__check{width:28px;height:28px;border-radius:50%;background:#3ea6b7;color:#fff;display:flex;align-items:center;justify-content:center;font-size:16px;flex-shrink:0;}' +
      '.of-added .of-upsell{margin:0;padding:10px;gap:8px;}' +
      '.of-added__box{padding:14px;gap:10px;}' +
      '.of-added .of-upsell__img{width:44px;height:44px;}' +
      '.of-added .of-btn{padding:11px!important;font-size:14px!important;}' +
      '.of-simple-cart .additional-checkout-buttons,.of-simple-cart shopify-accelerated-checkout-cart,.of-simple-cart [data-shopify=\"dynamic-checkout-cart\"]{display:none!important;}' +
      '.of-upsell--drawer{margin:16px 0 8px;padding:10px;gap:8px;}' +
      '.of-upsell--drawer .of-upsell__img{width:48px;height:48px;}' +
      '.of-upsell--drawer .of-btn{padding:10px!important;font-size:14px!important;}';
    document.head.appendChild(st);
  }

  /* where: 'popup' | 'drawer' | 'page' */
  function buildCard(list, where) {
    if (!Array.isArray(list)) list = [list];
    var wrap = document.createElement('div');
    wrap.className = 'of-upsell';
    wrap.setAttribute('data-of-upsell', list.map(function (x) { return x.handle; }).join(','));
    var head = '<div class="of-upsell__head"><span class="of-upsell__tag">Bundle &amp; Save 15%</span><span>' + (list.length > 1 ? 'Choose one' : 'Complete your stack') + '</span></div>';
    var tabs = '';
    if (list.length > 1) {
      tabs = '<div class="of-upsell__tabs">' + list.map(function (x, i) {
        var im = x.featured_image ? (x.featured_image.indexOf('//') === 0 ? 'https:' + x.featured_image : x.featured_image) : '';
        var short = x.handle === 'opti-flexiglow' ? 'Collagen' : (x.handle === 'opti-guard' ? 'L-Glutamine' : (x.handle === 'high-chief' ? 'High Chief' : x.title));
        return '<button type="button" class="of-upsell__tab' + (i === 0 ? ' is-on' : '') + '" data-i="' + i + '">' + (im ? '<img src="' + esc(im + (im.indexOf('?') > -1 ? '&' : '?') + 'width=80') + '" alt="">' : '') + '<span>' + esc(short) + '</span></button>';
      }).join('') + '</div>';
    }
    wrap.innerHTML = head + tabs + '<div data-of-body></div>';
    var body = wrap.querySelector('[data-of-body]');
    function show(i) {
      body.innerHTML = '';
      body.appendChild(buildOne(list[i], where, wrap));
      wrap.querySelectorAll('.of-upsell__tab').forEach(function (t) { t.classList.toggle('is-on', Number(t.getAttribute('data-i')) === i); });
    }
    wrap.querySelectorAll('.of-upsell__tab').forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); show(Number(t.getAttribute('data-i'))); });
    });
    show(0);
    return wrap;
  }

  function buildOne(p, where, wrap) {
    var avail = p.variants.filter(function (v) { return v.available; });
    var first = avail[0] || p.variants[0];
    var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
    var opts = '';
    if (p.variants.length > 1) {
      opts = '<select class="of-upsell__select" aria-label="Choose option">' +
        avail.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + '</option>'; }).join('') +
        '</select>';
    }
    var el = document.createElement('div');
    el.className = 'of-upsell__one';
    el.innerHTML =
      '<div class="of-upsell__row">' +
        '<div class="of-upsell__img">' + (img ? '<img src="' + esc(img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120') + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</div>' +
        '<div class="of-upsell__info"><span class="of-upsell__title">' + esc(p.title) + '</span>' +
        '<span class="of-upsell__price"><s>' + money(first.price) + '</s><strong>' + money(Math.round(first.price * 0.85)) + '</strong></span></div>' +
      '</div>' + opts +
      '<p class="of-upsell__note">15% off the added product (1 tub)</p>' +
      '<button type="button" class="of-btn of-upsell__btn" data-variant="' + first.id + '">Add &amp; Save 15%</button>';
    var btn = el.querySelector('.of-upsell__btn');
    var sel = el.querySelector('.of-upsell__select');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var id = sel ? sel.value : btn.getAttribute('data-variant');
      btn.disabled = true; btn.textContent = 'Adding...';
      addToCart(id, 1, bundleCode(p._main, p.handle)).then(function () {
        if (where === 'page' || onCartPage()) { location.reload(); return; }
        if (where === 'drawer') { refreshCartUI(true); return; }
        wrap.innerHTML = '<p class="of-upsell__done">&#10003; ' + esc(p.title) + ' added &ndash; 15% off applied in your cart</p>';
        refreshCartUI(false);
      }).catch(function () {
        btn.disabled = false; btn.textContent = 'Add & Save 15%';
        alert('Sorry, this product is not available right now.');
      });
    });
    return el;
  }

  function closePopup(m) {
    if (m && m.parentNode) m.parentNode.removeChild(m);
    popupOpen = false;
    document.documentElement.style.overflow = '';
  }

  function showAddedPopup(title, handle) {
    if (popupOpen) return;
    popupOpen = true;
    addStyles();
    hideDrawer();
    setTimeout(hideDrawer, 400);
    setTimeout(hideDrawer, 900);
    var m = null;
    function build(p) {
      if (m) return;
      m = document.createElement('div');
      m.className = 'of-added';
      m.innerHTML =
        '<div class="of-added__box" role="dialog" aria-modal="true" aria-label="Added to cart">' +
          '<div class="of-added__head"><span class="of-added__check">&#10003;</span><span>' + (title ? esc(title) + ' added to your cart' : 'Added to your cart') + '</span></div>' +
          '<div data-of-slot></div>' +
          '<a class="of-btn" href="' + root + 'cart">Go to Cart</a>' +
          '<button type="button" class="of-btn of-btn--ghost" data-of-close>Continue Shopping</button>' +
        '</div>';
      m.querySelector('[data-of-close]').addEventListener('click', function () { closePopup(m); });
      m.addEventListener('click', function (e) { if (e.target === m) closePopup(m); });
      if (p) m.querySelector('[data-of-slot]').appendChild(buildCard(p, 'popup'));
      document.body.appendChild(m);
      document.documentElement.style.overflow = 'hidden';
    }
    /* Show the popup only when the bundle is ready, so the customer sees it from the first moment */
    var work = getJSON(root + 'cart.js').then(function (c) { return pickSuggestion(c, handle); }).catch(function () { return null; });
    var timer = setTimeout(function () { build(null); }, 1800);
    work.then(function (p) {
      clearTimeout(timer);
      if (!m) { build(p); return; }
      if (p && m.parentNode) { var slot = m.querySelector('[data-of-slot]'); if (slot && !slot.firstChild) slot.appendChild(buildCard(p, 'popup')); }
    });
  }

  /* Watch the theme's own "Add to cart" requests */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    var p = nativeFetch(input, init);
    if (method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url) && !onCartPage()) {
      p.then(function (res) {
        if (!res.ok) return;
        res.clone().json().then(function (data) {
          if (data && data.status && data.status >= 400) return;
          var item = data && (data.items ? data.items[0] : data);
          showAddedPopup(item && (item.product_title || item.title), item && item.handle);
        }).catch(function () { showAddedPopup(''); });
      }).catch(function () {});
    }
    return p;
  };

  function drawerSlot(d) {
    var item = d.querySelector('[id^="CartDrawer-Item-"]');
    var sc = item ? item.closest('.drawer__scrollable') : null;
    return sc || (item ? item.parentElement : null);
  }

  function hideCartExtras() {
    document.querySelectorAll('[id^="CartDiscount-"], form[is="cart-discount"]').forEach(function (f) {
      var box = f.closest('details') || f.closest('.accordion') || f;
      if (box.style.display !== 'none') box.style.display = 'none';
    });
    document.querySelectorAll('main-cart p, main-cart div, cart-drawer p, cart-drawer div, #MainContent p').forEach(function (n) {
      if (n.children.length === 0 && /^\s*International shipments via DHL/i.test(n.textContent) && n.style.display !== 'none') n.style.display = 'none';
    });
  }

  function simpleCartPage() {
    if (!onCartPage()) return;
    addStyles();
    document.documentElement.classList.add('of-simple-cart');
    document.querySelectorAll('[name="checkout"]').forEach(function (b) {
      if (b.closest('cart-drawer') || b.closest('.of-added')) return;
      var holder = b.parentElement;
      if (!holder || !holder.parentElement || holder.parentElement.querySelector('[data-of-continue]')) return;
      var c = document.createElement('a');
      c.href = root + 'collections/all';
      c.className = 'of-btn of-btn--ghost';
      c.style.marginTop = '12px';
      c.setAttribute('data-of-continue', '');
      c.textContent = 'Continue Shopping';
      holder.parentElement.insertBefore(c, holder.nextSibling);
    });
  }

  var lastEnforce = 0;
  function run() {
    hideCartExtras();
    simpleCartPage();
    if (onCartPage() && Date.now() - lastEnforce > 1500) {
      lastEnforce = Date.now();
      getJSON(root + 'cart.js').then(enforceBundle).catch(function () {});
    }
    if (busy || Date.now() < coolUntil) return;
    var spots = [];
    document.querySelectorAll('cart-drawer').forEach(function (d) {
      var slot = drawerSlot(d);
      if (slot && !slot.querySelector('[data-of-upsell]')) spots.push({ parent: slot, before: null, where: 'drawer' });
    });
    if (!spots.length) return;
    busy = true;
    getJSON(root + 'cart.js').then(function (cart) {
      if (!cart.items || !cart.items.length) return null;
      return pickSuggestion(cart, cart.items[0].handle);
    }).then(function (p) {
      if (!p) { coolUntil = Date.now() + 4000; return; }
      addStyles();
      spots.forEach(function (sp) {
        if (sp.parent.querySelector('[data-of-upsell]')) return;
        var card = buildCard(p, sp.where);
        if (sp.where === 'drawer') card.classList.add('of-upsell--drawer');
        sp.parent.insertBefore(card, sp.before);
      });
    }).catch(function () {}).then(function () { busy = false; });
  }

  /* Cart icon in the header opens the full cart page (not the slide-up drawer) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.cart-drawer-button, header a[href$="/cart"], .header a[href$="/cart"], [aria-controls^="CartDrawer"]');
    if (!a || a.closest('cart-drawer') || a.closest('.of-added')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    location.href = root + 'cart';
  }, true);

  setTimeout(function () { OFFER.forEach(getProduct); }, 1200);
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(run, 350); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
